import React from 'react'
import { Row } from 'antd'
import { CustomCol, CustomTitle } from 'src/components'
import styles from './SaleProjectDetailsLabels.module.scss'
import type { ProjectSaleDetailLabels } from '../sale-project-details.helpers'

interface SaleProjectDetailsLabelsProps {
  labels: ProjectSaleDetailLabels[]
}

const SaleProjectDetailsLabels: React.FC<SaleProjectDetailsLabelsProps> = ({ labels }) => <>
  {labels.map((x, idx) => (
    <Row key={idx}>
      <CustomCol xs={12}>
        <CustomTitle label={x.label} />
      </CustomCol>
      <CustomCol xs={12} className={styles.texts}>
        <CustomTitle label={<>
          <strong>{x.strongLabel}</strong> &nbsp;
          {x.secondLabel && <span className={styles.label}>{x.secondLabel}</span>}
        </>} />
      </CustomCol>
    </Row>
  ))}
</>

export default SaleProjectDetailsLabels
